module.exports = __webpack_public_path__ + "img/Banner_web_placervp.2c3ea69e.jpg";